<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <b-row>
        <b-col>
          <b-card header="CSS FILES">
            <vuetable ref="vuetable" :api-url="api_url" :fields="fields" pagination-path="" :per-page="perPage" @vuetable:pagination-data="onPaginationData" :http-options="httpOptions">
              <template slot="actions" slot-scope="props">
                <div class="table-button-container">
                  <button class="btn btn-info" @click="editFile(props.rowData.name)"><i class="fa fa-edit"></i> Edit</button>&nbsp;&nbsp;
                  <button class="btn btn-danger" @click="deleteFile(props.rowData.name)"><i class="fa fa-remove"></i> Delete</button>&nbsp;&nbsp;
                </div>
              </template>
            </vuetable>
            <div class="vuetable-pagination ui basic segment grid">
              <vuetable-pagination-info ref="paginationInfo"></vuetable-pagination-info>
              <vuetable-pagination ref="pagination" @vuetable-pagination:change-page="onChangePage"></vuetable-pagination>
            </div>
          </b-card>
        </b-col>
      </b-row>
    </div>
    <b-modal size="lg" id="bannersInUse" ok-only ok-variant="secondary" ok-title="Close" :title="fileName" :hide-footer="hideFooter">
      <h1>CSS file in use by: </h1>
      <table class="table">
        <thead>
          <tr>
            <th scope="col">#</th>
            <th scope="col">Name</th>
            <th scope="col">Size</th>
            <th scope="col">Created:</th>
            <th scope="col">Edit Url:</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(banner, index) in isInUse" :key="banner._id">
            <th scope="row">{{index +1 }}</th>
            <td><a :href="generateHref(banner._id)" target="_BLANK">{{ banner.bannername }}</a></td>
            <td>{{ banner.size }}</td>
            <td>{{ $moment(banner.created_at).format('D/MM/YYYY') }}</td>
            <td><a :href="generateHref(banner._id)" target="_BLANK">/banners/edit/{{ banner._id }}</a></td>
          </tr>
        </tbody>
      </table>
      <button v-if="fName" class="btn btn-danger" @click.prevent="goAndEditFile(fName)"><i class="fa fa-edit"></i> Edit</button>&nbsp;&nbsp;
    </b-modal>
  </div>
</template>

<script>

import Vuetable from 'vuetable-2/src/components/Vuetable'
import VuetablePagination from 'vuetable-2/src/components/VuetablePagination'
import VuetablePaginationInfo from 'vuetable-2/src/components/VuetablePaginationInfo'

export default {
  components: {
    Vuetable,
    VuetablePagination,
    VuetablePaginationInfo
  },
  name: 'CreateCSS',
  data () {
    return {
      httpOptions: {
        baseURL: this.$http.defaults.baseURL,
        headers: this.$http.defaults.headers.common
      },
      errors: {},
      files: [],
      filesLoading: true,
      isInUse: [],
      modalTitle: '',
      fileName: '',
      perPage: 10,
      fName: '',
      fields: [
        {
          name: '__sequence', // <----
          title: '#',
          titleClass: 'center aligned',
          dataClass: 'right aligned'
        },
        {
          name: 'name',
          title: 'File Name',
          sortField: 'name',
          callback: 'formatUrl'
        },
        {
          name: 'created_at',
          title: 'Created',
          sortField: 'created_at',
          callback: 'formatDate'
        },
        {
          name: '__slot:actions',
          title: 'Actions',
          titleClass: 'text-center',
          dataClass: 'text-center'
        }

      ],
      api_url: '',
      sortOrder: [
        {
          field: 'created_at',
          sortField: 'created_at',
          direction: 'desc'
        }
      ]
    }
  },
  methods: {
    goAndEditFile (fName) {
      if (prompt(`Are you sure? Modifying this file will affect some banners.
      Type"${fName}" if you are ok with this.`) === fName) { return this.$router.push(`/css/update/${fName}`) }
    },
    onPaginationData (paginationData) {
      this.$refs.pagination.setPaginationData(paginationData)
      this.$refs.paginationInfo.setPaginationData(paginationData) // <----
    },
    onChangePage (page) {
      this.$refs.vuetable.changePage(page)
    },
    formatUrl (value) {
      return `<strong><a href="${this.$api_url + '/../css/' + value}" target="_blank">${value}</a></strong>`
    },
    reloadTable () {
      this.$refs.vuetable.refresh()
    },
    editFile (filename) {
      const fName = filename.split('.')[0]
      this.fName = fName
      const formData = new FormData()
      formData.append('filename', filename)
      this.$http.post(`${this.$api_url}/banner/checkIfCssFileIsInUse`, formData).then((data) => {
        this.isInUse = data.data.founded
      }).then((data) => {
        if (this.isInUse.length === 0) {
          this.$router.push(`/css/update/${fName}`)
        } else {
          this.modalTitle = filename
          this.$bvModal.show('bannersInUse')
        }
      }).catch((e) => {
        alert('An error ocured. Please try again later!')
      })
    },
    formatDate (value, fmt = 'D MMM YYYY') {
      return (value === null)
        ? ''
        : this.$moment(value).format(fmt)
    },
    generateHref (id) {
      return `/banners/edit/${id}`
    },
    generatePath (fName) {
      return `${this.$api_url}/../css/${fName}`
    },
    deleteFile (filename) {
      this.fileName = filename
      this.fName = ''

      const formData = new FormData()
      formData.append('filename', filename)
      this.$http.post(`${this.$api_url}/banner/checkIfCssFileIsInUse`, formData).then((data) => {
        this.isInUse = data.data.founded
      }).then((data) => {
        if (this.isInUse.length === 0) {
          this.isInUse = []
          const confirm = prompt('Are sure? Type "delete"')
          if (confirm === 'delete') {
            const formData = new FormData()
            formData.append('filename', filename)
            this.$http.post(`${this.$api_url}/removeCSS`, formData).then(() => {
              // nothing
            })

            // delete CSS file function
            this.reloadTable()
          }
          // delete file after confirm
        } else {
          this.modalTitle = filename
          this.$bvModal.show('bannersInUse')
        }
      }).catch((e) => {
        alert('An error ocured. Please try again later!')
      })
    },
    uploadFile () {
      /*
                Initialize the form data
            */
      const formData = new FormData()

      /*
                Add the form data we need to submit
            */
      formData.append('file', this.file)

      /*
          Make the request to the POST /single-file URL
        */
      this.$http
        .post(`${this.$api_url}/uploadCSS`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
        .then(function (data) {
          console.log('Success!')
        })
        .catch(function () {
          console.log('FAILURE!!')
        })
    },
    loadCSSList () {
      this.$http.get(`${this.$api_url}/scandircss`).then((data) => {
        if (data) {
          const dir = data.data.dir
          this.files = data.data.dirTree[dir]
          this.filesLoading = false
        }
      })
    }
  },
  created () {
    this.api_url = `${this.$api_url}/scandircss`
    // this.loadCSSList();
  },
  computed: {
    hideFooter () {
      return this.fName !== ''
    }
  }
}
</script>

<style scoped>
</style>
